import { createContext, useState } from 'react';
import api from 'services/api';

export const GrupoCnaeContext = createContext();

export const GrupoCnaeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [grupoCnae, setGrupoCnae] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getGrupoCnae = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: grupoCnae?.filter,
        page: grupoCnae?.page,
        size: grupoCnae?.size,
        order: grupoCnae?.order,
        ...payload,
      });
      setGrupoCnae((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <GrupoCnaeContext.Provider
      value={{
        getLoading,
        grupoCnae,
        getGrupoCnae,
      }}
    >
      {children}
    </GrupoCnaeContext.Provider>
  );
};
